import { Team } from '~/src/components/team';
import MinimalLayout from '~/src/layouts/minimal-layout';
import * as React from 'react';
export default {
  Team,
  MinimalLayout,
  React
};